"use strict";

export var SideDrawerListConstants = {
  SIDE_DRAWER_LIST_LOADED: 'SIDE_DRAWER_LIST_LOADED',
  SIDE_DRAWER_LIST_ITEM_EXPANDED: 'SIDE_DRAWER_LIST_ITEM_EXPANDED',
  SIDE_DRAWER_LIST_ITEM_CLICK: 'SIDE_DRAWER_LIST_ITEM_CLICK',
  SIDE_DRAWER_LIST_ITEM_ACTIVATE: 'SIDE_DRAWER_LIST_ITEM_ACTIVATE',
  SIDE_DRAWER_LIST_LOAD: 'SIDE_DRAWER_LIST_LOAD',
  SIDE_DRAWER_LIST_UPDATE_SCROLL_TOP: 'SIDE_DRAWER_LIST_UPDATE_SCROLL_TOP'
};